"use strict";

(function (Drupal) {
  Drupal.behaviors.launchpad = {
    attach: function attach(context, settings) {
      var slides = document.querySelectorAll('.launchpad__item');
      if (!slides.length) {
        return;
      }

      // gmap
      var slideMap = function slideMap(slides) {
        slides.forEach(function (item) {
          if (!item.getAttribute('data-is-map')) {
            return;
          }
          var lat = parseFloat(item.querySelector('.launchpad .latlon-lat').textContent);
          var lng = parseFloat(item.querySelector('.launchpad .latlon-lon').textContent);
        });
      };

      // init first slides
      var slideInit = function slideInit(slides) {
        slides[0].querySelector('.launchpad__item-image').setAttribute('data-animation', 'true');
        slides[0].querySelector('.launchpad__item-bg').setAttribute('data-animation', 'true');
      };
      slideInit(slides);
      slideMap(slides);
    }
  };
})(Drupal);